
import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';
import Poppy from 'poppy';
import {getUrlWithVariant, ProductForm} from './../theme-scripts/theme-product-form';
import {register} from './../exports/theme-sections';
import ajaxAddToCart from './../exports/addToCart';
import { tabs, destroyTabs } from './../exports/tabs';
import { getSwatch } from './../exports/get-colors';
// import { modal, productZoom } from './../exports/modals';
import Media from './../features/media';


const selectors = {
  productForm: '[data-product-form]',
  productJson: '[data-product-json]',
  optionsJson: '[data-product-options-json]',
  productImage: '[data-product-img]',
  productThumbs: '[data-product-thumbs]',
  addToCart: '[data-add-to-cart]',
  radioName: '[data-option-name]',
  addToCartText: '[data-add-to-cart-text]',
  productPrice: '[data-product-price]',
  buttonPrice: '[data-button-price]',
  comparePrice: '[data-compare-price]',
  productSlideshow: '[data-product-slideshow]',
  unitPrice: '[data-product-unit-price]',
  unitBase: '[data-product-base]',
  unitWrapper: '[data-product-unit]',
  quantityInput: '[data-quantity-input]',
  popupButton: '[data-toggle-product-modal]',
  idInput: '[name="id"]',
};


var product = {};
var variant = {};
window.theme = window.theme || {};

var thumbIcons = {
  model:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
  video:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
  external_video:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
};

class ProductTemplate {
  constructor(section) {
    this.id = section.id;
    this.container = section.container;
    this.settings = section.settings;
    this.productFormElement = this.container.querySelector(selectors.productForm);

    this.media = section.media;

    const productJSON = this.container.querySelector(selectors.productJson);
    const optionsJSON = this.container.querySelector(selectors.optionsJson);
    if (productJSON && productJSON.innerHTML !== '') {
      product = this.product = JSON.parse(productJSON.innerHTML);
      this.options = JSON.parse(optionsJSON.innerHTML).options;
    } else {
      console.error('Missing product JSON');
      return;
    }

    this.init();
  }
  init() {

    this.initializeForm();
    this.quantitySelectors();

    this.hasUnitPricing = (this.container.querySelector(selectors.unitWrapper) !== null);

    if (this.settings.swatches_enable) {
      this.swatchButtons();
    }
    // if (this.settings.zoom_enable) {
    //   productZoom(this.container, this.product);
    // }

    this.ajaxAddListner();

    // for history state url load
    // updateImages(variant, this.container);
    updateImages(variant, this.container, this.media);
    this.customHook(variant);
  }
  customHook(variant) {
    this.container.dispatchEvent(new CustomEvent('theme:variant:change', {
      detail: {
        variant: variant,
      },
      bubbles: true,
    }));
  }
  onOptionChange(event) {
    variant = event.dataset.variant;
    updatePrices(variant, this.container);
    if (this.hasUnitPricing) {
      updateProductUnits(variant, this.container);
    }
    // updateImages(variant, this.container);
    updateImages(variant, this.container, this.media);
    updateButtonPrice(variant, this.container);
    updateHiddenSelect(variant, this.container);
    updateRadioNames(variant, this.container);
    updateRemaining(variant, this.container);
    updateHistoryState(variant);
    this.customHook(variant);
  }
  onQuantityChange(event) {
    variant = event.dataset.variant;
    updateButtonPrice(variant, this.container);
  }
  ajaxAddListner() {
    $(selectors.addToCart, this.container).on('click', function(evt) {
      var isFocusEnabled = $('body').hasClass('focus-enabled');
      if (isFocusEnabled) {
        return;
      }
      evt.preventDefault();
      var $form = $(this).closest('form');
      var form_serialized = $form.serializeArray();
      if ($form.find('[type="file"]').length) {
        return;
      }
      var form_object = {};
      $.map(form_serialized, function(val) {
        form_object[val.name] = val.value;
      });
      ajaxAddToCart(form_object);
    });
  }
  swatchButtons() {
    const labelsArray = window.theme.strings.swatchesKey
      .split(',')
      .map(s => s.trim());
    labelsArray.forEach(label => {
      var element = this.container.querySelector(`[data-select-label~="${label}" i]`);
      if (element) {
        this.newSwatch(label, element);
      }
    });
  }
  async newSwatch(label, element) {
    var position = parseInt(element.getAttribute('data-select-position'), 10);
    var tooltip = `data-tooltip-${this.product.id}-${getRandomInt(1, 20)}`;
    position--; // shopify positions are not zero based
    var legend = `<legend class="radio__legend">
                    <span class="radio__legend__label">${label}</span>
                    <span data-option-name>${variant.options[position]}</span>
                  </legend>`;
    var swatches = this.options[position].values;
    var swatchElement = document.createElement('fieldset');
    swatchElement.setAttribute('class', 'radio__fieldset radio__fieldset--swatch');
    swatchElement.innerHTML = legend;
    element.innerHTML = null;
    element.appendChild(swatchElement);

    var swatcheButtonsElement = document.createElement('div');
    swatcheButtonsElement.setAttribute('class', 'swatch__buttons');
    swatcheButtonsElement.setAttribute('data-swatch-button-slider', '');
    element.appendChild(swatcheButtonsElement);


    let colorOption = -1;
    for (var i=0 ; i<product.options.length ; i++) {
      if( product.options[i] == 'Color' ) {
        colorOption = i;
      }
    }

    for (var i=0 ; i<swatches.length ; i++) {
      var value = swatches[i];
      var swatch = await getSwatch(value);
      var hex = swatch.hex;

      let swatchImage = '';
      if( colorOption != -1 ) {
        var featuredImage = false;
        for(var j=0 ; j<product.variants.length ; j++) {
          var colorOptionKey = 'option'+(colorOption+1);
          if( value == product.variants[j][colorOptionKey] ) {
            featuredImage = product.variants[j].featured_image
          }
        }
        if( featuredImage ) {
          swatchImage = ` background-image: url('${featuredImage.src}'); background-size: cover;`;
        }
      } else {
        if (swatch.path) {
          swatchImage = ` background-image: url('${swatch.path}'); background-size: cover;`;
        }
      }

      var id = `${label}[${value}]`;
      var checked = '';
      if (variant.options[position] === value) {
        checked = 'checked';
      }
      var option = `<span class="swatch__button">
        <input type="radio" name="options[${label}]" value="${value}" id="${id}" ${checked}>
        <label for="${id}" style="--swatch: ${hex}; ${swatchImage}" >
          <span class="visually-hidden">${value}</span>
        </label>
      </span>`;
      // var option = `<span class="swatch__button" ${tooltip}>
      //   <input type="radio" name="options[${label}]" value="${value}" id="${id}" ${checked}>
      //   <label for="${id}" style="--swatch: ${hex}; ${swatchImage}" >
      //     <span class="visually-hidden">${value}</span>
      //   </label>
      // </span>`;
      swatcheButtonsElement.innerHTML += option;
    }
    /*
    const poppies = [];
    const buttons = this.container.querySelectorAll(`[${tooltip}]`);
    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      const pop = new Poppy({
        target: button,
        popover: `
          <div class="poppy__tooltip__wrapper">
            <div class="poppy__tooltip">
              ${swatches[i]}
            </div>
          </div>
        `,
        position: 'top',
        transitionSpeed: 200,
      });
      button.addEventListener('mouseenter', pop.pin);
      button.addEventListener('mouseleave', pop.unpin);
      poppies.push(pop);
    }
    */
    this.initializeForm();
    let $swatchSlider = $(this.container).find('[data-swatch-button-slider]'),
        currentSlickIndex = -1
    $swatchSlider
      .on('init', function(){
        let $selectedRadio = $swatchSlider.find(' [type="radio"]:checked');
        if( $selectedRadio.length ) {
          currentSlickIndex = parseInt( $selectedRadio.closest('.slick-slide').attr('data-slick-index') );
        }
      })
      .slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false
      });
    if ( currentSlickIndex !== -1  ){
      $swatchSlider.slick('goTo', currentSlickIndex);
    }

    $('[data-split-select-wrapper]').removeClass('selector-wrapper--placeholder');
  }
  initializeForm() {
    if (typeof this.productForm !== 'undefined') {
      this.productForm.destroy();
    }
    this.productForm = new ProductForm(this.productFormElement, this.product, {
      onOptionChange: this.onOptionChange.bind(this),
      onQuantityChange: this.onQuantityChange.bind(this),
    });
    try {
      variant = this.productForm.variant();
    } catch (err) {
      // product has only one variant
      variant = this.productForm.product.variants[0];
    }
  }
  quantitySelectors() {
    // Setup listeners to add/subtract from the input
    $('.js-qty__adjust').off().on('click', function() {
      var $el = $(this);
      var $quantitySelector = $el.siblings('.js-qty__num');
      var quantity = getQuantity(this.quantity);
      if ($el.hasClass('js-qty__adjust--plus')) {
        quantity += 1;
      } else {
        quantity -= 1;
        if (quantity <= 1) {
          quantity = 1;
        }
      }
      // Update the input's number
      $quantitySelector.val(quantity).change();
      updateButtonPrice(variant, this.container);
    });
  }
}


function getQuantity(container) {
  var $quantityInput = $(selectors.quantityInput, container);
  var quantity = 1;
  if ($quantityInput.length) {
    quantity = parseInt($quantityInput.val().replace(/\D/g, ''), 10);
  }
  // Make sure we have a valid integer
  if (parseFloat(quantity) == parseInt(quantity, 10) && !isNaN(quantity)) {
    // We have a number!
  } else {
    // Not a number. Default to 1.
    quantity = 1;
  }
  return quantity;
}

function updateButtonPrice(variant, container) {
  if (variant) {
    var quantity = getQuantity(container);
    var quantityLabel = '';
    if (quantity > 1) {
      quantityLabel = `(${quantity})`;
    }
    var price = formatMoney(variant.price * quantity, theme.moneyFormat);
    $(selectors.buttonPrice, container).html(`${price}&nbsp;${quantityLabel}`);
  }
}

function updateRadioNames(variant, container) {
  if (variant) {
    var $names = $(selectors.radioName, container);
    $names.each(function() {
      var $name = $(this);
      var position = $name.parents('[data-select-position]').attr('data-select-position');
      var index = parseInt(position, 10) - 1;
      var value = variant.options[index];
      $name.html(value);
    });
  }
}

function updateHiddenSelect(variant, container) {
  if (variant) {
    var idInputElement = container.querySelector(selectors.idInput);
    if (!idInputElement) {
      idInputElement = document.createElement('input');
      idInputElement.type = 'hidden';
      idInputElement.name = 'id';
      this.element.appendChild(idInputElement);
    }
    idInputElement.value = variant.id.toString();
  }
}

function updatePrices(variant, container) {

  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $(selectors.addToCart, container).removeClass('disabled').prop('disabled', false);
      $(selectors.addToCartText, container).html(theme.strings.addToCart);
      $(container).removeClass('variant--soldout variant--unavailabe');
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $(selectors.addToCart, container).addClass('disabled').prop('disabled', true);
      $(selectors.addToCartText, container).html(theme.strings.soldOut);
      $(container).removeClass('variant--unavailabe').addClass('variant--soldout');
    }
    // Regardless of stock, update the product price
    $(selectors.productPrice, container).html(formatMoney(variant.price, theme.moneyFormat));

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $(selectors.comparePrice, container).html(formatMoney(variant.compare_at_price, theme.moneyFormat));
      $(selectors.comparePrice, container).closest('.compare-at').show();
      $(selectors.productPrice, container).closest('.product__price').addClass('on-sale');
    } else {
      $(selectors.comparePrice, container).closest('.compare-at').hide();
      $(selectors.productPrice, container).closest('.product__price').removeClass('on-sale');
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $(selectors.addToCart, container).addClass('disabled').prop('disabled', true);
    $(selectors.addToCartText, container).html(theme.strings.unavailable);
    $(container).removeClass('variant--soldout').addClass('variant--unavailabe');
  }
}

// Change unit price for variants
function updateProductUnits(variant, container) {
  if (typeof variant.unit_price !== 'undefined') {
    const price = formatMoney(variant.unit_price, theme.moneyFormat);
    const base = getBaseUnit(variant);
    $(selectors.unitPrice, container).html(price);
    $(selectors.unitBase, container).html(base);
    $(selectors.unitWrapper, container).show();
  } else {
    $(selectors.unitWrapper, container).hide();
  }
}

function getBaseUnit(variant) {
  return variant.unit_price_measurement.reference_value === 1
  ? variant.unit_price_measurement.reference_unit
  : variant.unit_price_measurement.reference_value +
  variant.unit_price_measurement.reference_unit;
}

let pOption1 = false;
function updateImages(variant, container, media) {
  if ( variant ) {
    let productJSON = container.querySelector(selectors.productJson),
        productObject = JSON.parse( productJSON.innerHTML );

    if( productObject.options[0] == 'Color' &&
        pOption1 != variant.option1 ) {
      media.reinit([ variant.option1, 'All' ]);
    }
    pOption1 = variant.option1;
  }
}

function _updateImages(variant, container) {
  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_media) {
      var $newImg = $('[data-image-id="' + variant.featured_media.id + '"]', container);
      var newPosition = $newImg.closest('.slick-slide:not(.slick-cloned)').attr('data-slick-index');
      // Slider not loaded
      if (newPosition === undefined) {
        // do nothing
      } else {
        $(selectors.productSlideshow, container).slick('slickGoTo', newPosition);
      }
    }
  }
}

function updateHistoryState(variant) {
  const url = window.location.href;

  if (variant && url.includes('/product')) {
    const urlWithVariant = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: urlWithVariant }, '', urlWithVariant);
  }
}

function updateRemaining(variant, container) {
  var $remaining = $('[data-remaining-count]', container);
  var $remainingWrapper = $('[data-remaining-wrapper]', container);
  if (!variant) {
    $remainingWrapper.removeClass('variant__countdown--show');
    return;
  }
  if ($remaining.length) {
    var maxInventory = parseInt($remaining.attr('data-remaining-max'), 10);
    var sellout = (variant.inventory_policy === 'deny');
    if (variant.inventory_management && sellout) {
      var remainingInventory = variant.inventory_quantity;
      if (remainingInventory > 0 && remainingInventory <= maxInventory) {
        $remaining.html(variant.inventory_quantity);
        $remainingWrapper.addClass('variant__countdown--show');
      } else {
        $remainingWrapper.removeClass('variant__countdown--show');
      }
    } else {
      $remainingWrapper.removeClass('variant__countdown--show');
    }
  }
}

function getSectionSettings(container, id) {
  var rawJSON = $(container).find(`[data-settings='${id}']`).html();
  if (typeof rawJSON !== 'undefined') {
    return JSON.parse(rawJSON).settings;
  } else {
    return null;
  }
}

function getRandomInt(minimum, maximum) {
  var min = Math.ceil(minimum);
  var max = Math.floor(maximum);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const productSection = {
  onLoad() {
    const sectionSettings = getSectionSettings(this.container, this.id);
    this.settings = { ...sectionSettings, ...window.theme.settings };

    // modal(this.id);
    this.media = new Media(this);
    this.media.init();

    this.productTemplate = new ProductTemplate(this);
    tabs(this.container);
  },
  onUnload() {
    destroyTabs(this.container);
    this.media.destroy();
    this.productTemplate.destroy();
  },
  onBlockSelect(evt) {
    $('*[data-block-id="' + evt.detail.blockId + '"]').click();
  },
  onBlockDeselect(evt) {
    $('*[data-block-id="' + evt.detail.blockId + '"]').click();
  },
};

register('product', productSection);
